import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  supplierOrders: [],
  total: 0
};

const getters = {};

const actions = {
  LOAD_SUPPLIER_ORDERS: async function({ commit }, payload) {
    let numberQuery = payload.number ? "&number=" + payload.number:'';
    let surgeryIdQuery = payload.surgeryId ? "&surgeryId=" + payload.surgeryId: '';
    let orderStatudIdQuery = payload.orderStatusId ? "&orderStatusId=" + payload.orderStatusId: '';
    await Vue.prototype.$axios
      .get(
        "/suppliers/orders?from=" + payload.from +
        "&limit=" + payload.to +
        numberQuery +
        surgeryIdQuery +
        orderStatudIdQuery
      )
      .then(res => {
        commit("SET_SUPPLIER_ORDERS", res.data.supplierOrders);
        commit("SET_TOTAL", res.data.meta.total);
      });
  }
};

const mutations = {
  SET_SUPPLIER_ORDERS: function(state, payload) {
    state.supplierOrders = payload;
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
